import {Component, OnInit, ViewChild} from '@angular/core';
import {DialogRef} from "@progress/kendo-angular-dialog";
import {NgForm} from "@angular/forms";
import {PromocoesService} from "../services/promocoes.service";
import {EmpresasService} from "../../superadmin/services/empresas.service";
import {ProdutoService} from "../../services/produto.service";
import {descrevaRegra, iconeDaRegra} from "./regras-promocao";
declare let moment;

@Component({
  selector: 'app-cad-promocao',
  templateUrl: './cad-promocao.component.html',
  styleUrls: ['./cad-promocao.component.scss']
})
export class CadPromocaoComponent implements OnInit {
  @ViewChild('frm') frm: NgForm;
  promocao: any = {
    regras: [],
    ativa: true
  }
  windowRef: DialogRef;
  novaRegra: boolean;
  private buscando: any;
  private timerBusca: any;
  disponibilidadesSemana  = [
    { dia: 0 , label: 'Dom', disponivel: false },
    { dia: 1 , label: 'Seg', disponivel: false },
    { dia: 2 , label: 'Ter', disponivel: false },
    { dia: 3 , label: 'Qua', disponivel: false },
    { dia: 4 , label: 'Qui', disponivel: false },
    { dia: 5 , label: 'Sex', disponivel: false },
    { dia: 6 , label: 'Sab', disponivel: false }
  ]
  constructor(private promocoesService: PromocoesService,
              private produtoService: ProdutoService,
              private empresasService: EmpresasService) {
    this.hoje = moment().toDate();

    this.empresasService.obtenhaTemplatesEmpresaLogada( ).then( (templates) => {
      if(templates && templates.length){
        templates.forEach( template => {
          template.tamanhos.forEach( tamanho => {
            this.tamanhos.push( { id: tamanho.id, descricao: String(`${template.nome} - ${tamanho.descricao}`)});
          })
        })

        if(this.regra) {
          if(this.regra.tamanhoPizzaComprar){
            this.regra.tamanhoPizzaComprar =
              this.tamanhos.find( tamanhoPizza => tamanhoPizza.id ===  this.regra.tamanhoPizzaComprar.id)
          }
          if(this.regra.tamanhoPizzaGanhar){
            this.regra.tamanhoPizzaGanhar =
              this.tamanhos.find( tamanhoPizza => tamanhoPizza.id ===  this.regra.tamanhoPizzaGanhar.id)
          }
        }

        console.log(this.tamanhos)

      }
    });
  }
  hoje: any;
  mensagemErro: string;
  salvando = false;
  carregando = false;
  abraDialogoRegra = false;
  regra: any = {};
  regraEditada: any;
  produtos: any = [   { descricao: ''}];
  tamanhos: any = [ {descricao: ''}];
  private texto: string;
  descrevaRegra = descrevaRegra;
  iconeDaRegra = iconeDaRegra;
  tiposDeRegra: any[] = [ {
    descricao: "Desconto no produto",
    dica: "Um produto específico sai mais barato",
    icone: iconeDaRegra({tipo: 'percentual'}),
    id: 'percentual'
  }, {
    descricao: "Desconto no segundo",
    dica: "Levando dois, o segundo sai com desconto",
    icone: iconeDaRegra({tipo: 'percentual-no-segundo'}),
    id: 'percentual-no-segundo'
  }, {
    descricao: "Desconto em tudo",
    dica: "Percentual em qualquer produto do carrinho",
    icone: iconeDaRegra({tipo: 'percentual-todos'}),
    id: 'percentual-todos'
  }, {
    descricao: "Brinde com desconto",
    dica: "Produto entra no carrinho ao atingir um valor",
    icone: iconeDaRegra({tipo: 'adicionar-produto'}),
    id: 'adicionar-produto'
  }, {
    descricao: "Compre pizza, ganhe outra",
    dica: "Comprando pizzas de um tamanho, ganha outra",
    icone: iconeDaRegra({tipo: 'compre-pizza-ganhe-outra'}),
    id: 'compre-pizza-ganhe-outra'
  }

  ];


  ngOnInit(): void {
    if(this.promocao.dataInicio) this.promocao.dataInicio = new Date(this.promocao.dataInicio)
    if(this.promocao.dataFim) this.promocao.dataFim = new Date(this.promocao.dataFim)

    this.disponibilidadesSemana.forEach( (ds: any) => {
      ds.disponivel = (this.promocao.horarios || []).find( horario => horario.dia === ds.dia) != null
    })

    this.busqueProdutos('')

  }

  onSalvar() {
    if(this.frm.valid){
      this.salvando = true;
      this.promocao.regras = this.promocao.regras.filter(regra => !regra.removida )
      this.promocao.horarios = this.disponibilidadesSemana.filter( (ds: any) => ds.disponivel)

      this.promocoesService.salvePromocao(this.promocao).then( (resp) => {
        if(!this.promocao.id)
          this.promocao.id = resp.id;
        this.windowRef.close(this.promocao);
      }).catch( erro => {
        this.salvando = false;
        this.mensagemErro = erro;
      })
    } else {
      this.mensagemErro = 'O formulário não é válido'
    }


    console.log(this.frm)
  }

  fechar() {
    this.windowRef.close();
  }

  algumDiaMarcado() {
    return this.disponibilidadesSemana.some(ds => ds.disponivel);
  }

  totalRegrasValidas() {
    return this.promocao.regras.filter(regra => !regra.removida).length;
  }

  marqueDias(atalho: string) {
    const atalhos: any = { todos: [], uteis: [1, 2, 3, 4, 5], fds: [0, 6] };
    const dias = atalhos[atalho];

    this.disponibilidadesSemana.forEach(ds => ds.disponivel = dias.indexOf(ds.dia) >= 0);
  }

  atalhoDias() {
    const marcados = this.disponibilidadesSemana.filter(ds => ds.disponivel).map(ds => ds.dia).join(',');

    if(!marcados || marcados === '0,1,2,3,4,5,6') return 'todos';
    if(marcados === '1,2,3,4,5') return 'uteis';
    if(marcados === '0,6') return 'fds';

    return null;
  }

  diasTexto() {
    if(this.atalhoDias() === 'todos') return 'Todos os dias';
    if(this.atalhoDias() === 'uteis') return 'Segunda a sexta';
    if(this.atalhoDias() === 'fds') return 'Fim de semana';

    return this.disponibilidadesSemana.filter(ds => ds.disponivel).map(ds => ds.label).join(', ');
  }

  periodoTexto() {
    const formate = (data: any) => moment(data).format('DD/MM/YY');
    const { dataInicio, dataFim } = this.promocao;

    if(dataInicio && dataFim) {
      const mesmoAno = moment(dataInicio).year() === moment(dataFim).year();

      return `${mesmoAno ? moment(dataInicio).format('DD/MM') : formate(dataInicio)} – ${formate(dataFim)}`;
    }
    if(dataInicio) return `A partir de ${formate(dataInicio)}`;
    if(dataFim) return `Até ${formate(dataFim)}`;

    return 'Defina o período';
  }

  maiorDesconto() {
    const percentuais = this.promocao.regras
      .filter(regra => !regra.removida && regra.percentual > 0)
      .map(regra => Number(regra.percentual));

    return percentuais.length ? Math.max(...percentuais) : null;
  }

  onSelectedChange(ds, selecionou) {
    ds.disponivel = selecionou;
  }

  editarRegra(regra: any) {
    this.regra = {    }
    this.regraEditada = regra

    Object.assign(this.regra, this.regraEditada)
    this.novaRegra = false;

    if(this.regra.produto)
      this.busqueProdutos(this.regra.produto.nome, () => {
        let produtoBuscado = this.produtos.find(produto => produto.id === this.regra.produto.id)

        if(produtoBuscado) this.regra.produto = produtoBuscado
      })

    this.abraDialogoRegra = true;
  }


  removerRegra(regra: any) {
    // Regra ainda não salva sai direto; a salva fica marcada e pode ser desfeita.
    if(!regra.id) {
      this.promocao.regras.splice(this.promocao.regras.indexOf(regra), 1);
      return;
    }

    regra.removida = true;
  }

  adicionarRegra(tipo: string = null) {
    this.novaRegra = true;
    this.regra = { ativa: true, tipo: tipo }
    this.abraDialogoRegra = true;


    return false;
  }

  cancelarRemocao($event: MouseEvent, dataItem: any) {
    dataItem.removida = false;
  }

  fecharDialogRegra() {
    this.regra = null;
    this.abraDialogoRegra = false;
  }

  salvarRegra(frmRegra: NgForm) {
    if(!this.regra.tipo) return;

    if(this.novaRegra) {
      this.promocao.regras.push(this.regra)
    } else {
      Object.assign(this.regraEditada, this.regra)
    }

    this.fecharDialogRegra()
  }

  search($event: any, esconderZerado: boolean = false) {
    if(this.timerBusca) clearTimeout(this.timerBusca);

    this.timerBusca = setTimeout( () => {
      this.busqueProdutos($event, null, esconderZerado)
    }, 1000)
  }

  busquePrimeiraVez(esconderZerado: boolean = false) {
    if(!this.produtos.length){
      this.busqueProdutos('', null, esconderZerado);
    }
  }

  busqueProdutos(texto: string = '', cb = null, esconderZerado: boolean = false) {
    if(this.buscando) return;

    this.buscando = true;

    this.produtoService.autoComplete( texto, true, false, esconderZerado).then (  (produtos) => {
      this.produtos = produtos;
      this.buscando = false;

      if(cb) cb();


    }).catch( () => {
      console.log('Aconteceu erro ao buscar')
      this.buscando = false;
    })

  }

  obtenhaFormatoPercentual() {
    return String(`0.00"%"`);
  }

  busqueTamanhos() {

    return this.tamanhos
  }
}
